import { createSlice } from '@reduxjs/toolkit';

const initState = {
    enable: false,
    message: '',
    success:false
};

export const slice = createSlice({
    name: 'Auth',
    initialState: { ...initState },
    reducers: {
        showToast: (state, action) => {
            state.enable = true;
            state.message = action.payload.message;
            state.success = action.payload.success;

        },
        hideToast: (state) => {
            state.enable = false;
            state.success = false;
            state.message = '';
        }
    }
});

export const { showToast, hideToast } = slice.actions;
export default slice.reducer;
